import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Contact } from '../../contacts/shared/contact';
import { Customer } from '../../customer';
import { ApiResponse, ApiService } from '../api/api.service';

@Injectable()
export class CustomerService {
    constructor(private apiService: ApiService) {}

    private _customers: Customer[] = [];

    public set customers(customers) {
        this._customers = customers;
    }

    public getRecentSortedList(): Observable<Customer[]> {
        return this.apiService.getCallData$<Customer[]>('customers/recent-sorted');
    }

    public getList(): Observable<Customer[]> {
        if (this._customers && this._customers.length > 0) {
            return of(this._customers);
        }
        return this.apiService
            .getCallData$('customers')
            .pipe(tap((customers: Customer[]) => (this._customers = customers)));
    }

    public saveCustomerIcon(icon) {
        return this.apiService.postCall$('customers/icon', { icon });
    }

    public getSingle(customerId: number): Observable<Customer> {
        return this.apiService.getCallData$(`customers/${customerId}`, { apiResponse: true });
    }

    public contacts(customerprojectId: number): Observable<Contact[]> {
        return this.apiService.getCallData$(`contacts`, { customer_project_id: customerprojectId });
    }

    public contact(customerId: number, contactId: number): Observable<Contact> {
        return this.apiService.getCallData$(`customers/${customerId}/contacts/${contactId}`);
    }

    public storeContact(customerId: number, contact: Contact): Observable<ApiResponse<Contact>> {
        return this.apiService.postCall$<Contact>(`customers/${customerId}/contacts`, { contact });
    }

    public deleteContact(customerId: number, contactId: number): Observable<ApiResponse<Contact>> {
        return this.apiService.deleteCall$<Contact>(`customers/${customerId}/contacts/${contactId}`);
    }

    public archiveCustomer(customerId: number) {
        return this.apiService.deleteCall$(`customers/${customerId}`);
    }

    public saveDefaultPdfStyle(customerId: number, pdfStyleKey: string | null) {
        return this.apiService
            .postCall$<Customer>(`customers/default-pdf-style/${customerId}`, { default_pdf_style_key: pdfStyleKey })
            .pipe(map(r => r.data));
    }
}
